<template>
  <!--
    DsSkeleton — placeholder de carga del DS. Bloque flexible (height/width/radius/margin)
    con shimmer tokenizado en vellum (cálido, in-brand). `dark` para superficies oscuras
    (sidebars/immersive). Respeta prefers-reduced-motion. Convención de loading en
    docs/migration-ledger.md (#loading).
  -->
  <div class="ds-skeleton" :class="{ 'ds-skeleton--dark': dark }" aria-hidden="true">&nbsp;</div>
</template>

<script>
export default {
  name: 'DsSkeleton',
  props: {
    height: { type: String, default: '16px' },
    width: { type: String, default: '100%' },
    borderRadius: { type: String, default: 'var(--radius-sm)' },
    margin: { type: String, default: '0' },
    /** superficie oscura (sidebars, immersive). */
    dark: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="scss">
@keyframes ds-skeleton-shimmer {
  0%   { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

.ds-skeleton {
  display: block;
  height: v-bind(height);
  width: v-bind(width);
  margin: v-bind(margin);
  border-radius: v-bind(borderRadius);
  // Shimmer cálido: base vellum-200, barra de brillo vellum-50 (in-brand, sin shadow).
  background-color: var(--vellum-200);
  background-image: linear-gradient(
    to right,
    var(--vellum-200) 0%,
    var(--vellum-50) 12%,
    var(--vellum-200) 24%,
    var(--vellum-200) 100%
  );
  background-size: 200% 100%;
  background-repeat: no-repeat;
  animation: ds-skeleton-shimmer 1.4s linear infinite;
}

// Superficies oscuras: brillo con alpha claro sobre transparente.
.ds-skeleton--dark {
  background-color: rgba(255, 255, 255, 0.06);
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.06) 0%,
    rgba(255, 255, 255, 0.14) 12%,
    rgba(255, 255, 255, 0.06) 24%,
    rgba(255, 255, 255, 0.06) 100%
  );
}

@media (prefers-reduced-motion: reduce) {
  .ds-skeleton { animation: none; background-image: none; }
}
</style>
